import { patientMedicalInfoType } from "./Profile/PatientProfile";
import dayjs, { Dayjs } from "dayjs";
import { z } from "zod";
import { PatientMedicalInfoSchema } from "./MedicalProfile/PatientMedicalProfileForm";
var _ = require("lodash");

// functions

export function mapPatientMedicalInfoToState(patientMedicalInfo, patientId) {
  const patientInfoState = PatientMedicalInfoSchema.parse({
    id: undefined,
    diabetesMellitus: false,
    hypertension: false,
    ishaemicHeartDisease: false,
    respiratoryDisorders: false,
    allergies: false,
    previousSurgeries: false,
    bloodDyscrasias: false,
    hypothyroidism: false,
    pregnancyAndRelatedIssues: false,
    psychiatricAilments: false,
    dateOfBirth: undefined,
    gender: undefined,
    bloodGroup: undefined,
    other: undefined,
  });

  if (!_.isEmpty(patientMedicalInfo) && patientMedicalInfo.id != null) {
    patientInfoState.id = patientMedicalInfo.id;
  }
  if (
    !_.isEmpty(patientMedicalInfo) &&
    patientMedicalInfo.diabetesMellitus != null
  ) {
    patientInfoState.diabetesMellitus = patientMedicalInfo.diabetesMellitus;
  }
  if (
    !_.isEmpty(patientMedicalInfo) &&
    patientMedicalInfo.hypertension != null
  ) {
    patientInfoState.hypertension = patientMedicalInfo.hypertension;
  }
  if (
    !_.isEmpty(patientMedicalInfo) &&
    patientMedicalInfo.ishaemicHeartDisease != null
  ) {
    patientInfoState.ishaemicHeartDisease =
      patientMedicalInfo.ishaemicHeartDisease;
  }
  if (
    !_.isEmpty(patientMedicalInfo) &&
    patientMedicalInfo.respiratoryDisorders != null
  ) {
    patientInfoState.respiratoryDisorders =
      patientMedicalInfo.respiratoryDisorders;
  }
  if (!_.isEmpty(patientMedicalInfo) && patientMedicalInfo.allergies != null) {
    patientInfoState.allergies = patientMedicalInfo.allergies;
  }
  if (
    !_.isEmpty(patientMedicalInfo) &&
    patientMedicalInfo.previousSurgeries != null
  ) {
    patientInfoState.previousSurgeries = patientMedicalInfo.previousSurgeries;
  }
  if (
    !_.isEmpty(patientMedicalInfo) &&
    patientMedicalInfo.bloodDyscrasias != null
  ) {
    patientInfoState.bloodDyscrasias = patientMedicalInfo.bloodDyscrasias;
  }
  if (
    !_.isEmpty(patientMedicalInfo) &&
    patientMedicalInfo.hypothyroidism != null
  ) {
    patientInfoState.hypothyroidism = patientMedicalInfo.hypothyroidism;
  }
  if (
    !_.isEmpty(patientMedicalInfo) &&
    patientMedicalInfo.pregnancyAndRelatedIssues != null
  ) {
    patientInfoState.pregnancyAndRelatedIssues =
      patientMedicalInfo.pregnancyAndRelatedIssues;
  }
  if (
    !_.isEmpty(patientMedicalInfo) &&
    patientMedicalInfo.psychiatricAilments != null
  ) {
    patientInfoState.psychiatricAilments =
      patientMedicalInfo.psychiatricAilments;
  }
  if (
    !_.isEmpty(patientMedicalInfo) &&
    patientMedicalInfo.dateOfBirth != null
  ) {
    patientInfoState.dateOfBirth = dayjs(patientMedicalInfo.dateOfBirth);
  }
  if (!_.isEmpty(patientMedicalInfo) && patientMedicalInfo.gender != null) {
    patientInfoState.gender = patientMedicalInfo.gender;
  }
  if (!_.isEmpty(patientMedicalInfo) && patientMedicalInfo.bloodGroup != null) {
    patientInfoState.bloodGroup = patientMedicalInfo.bloodGroup;
  }
  if (!_.isEmpty(patientMedicalInfo) && patientMedicalInfo.other != null) {
    patientInfoState.other = patientMedicalInfo.other;
  }
  return patientInfoState;
}

export function removeFirstOccurrence(superString, subString) {
  const index = superString.indexOf(subString);
  if (index !== -1) {
    return (
      superString.slice(0, index) +
      superString.slice(index + subString.length).replace(/"/g, "")
    ).trim();
  }
  return superString.replace(/"/g, "").trim();
}
